import { Box, FormError, tokens } from '@vp/swan';

// FormErrorWrapper reserves height for the FormError to toggle its appearance
// beneath a TextInput and prevent content layout shift.
// Swan team have said this space reservation is the responsibility of the page
// context where the FormError is used.
// See: https://vistaprint.slack.com/archives/CB9FVD94J/p1724810010549059

interface FormErrorWrapperProps {
    errorMessage: string;
    errorId?: string;
}

const FormErrorWrapper = ({ errorMessage, errorId }: FormErrorWrapperProps) => {
    return (
        <Box style={{ minHeight: tokens.SwanSemSpace6 }}>
            {errorMessage && (
                <FormError marginTop={0} paddingTop={1} role="alert" id={errorId}>
                    {errorMessage}
                </FormError>
            )}
        </Box>
    );
};

export default FormErrorWrapper;
